import quotesEn from './quotes_en'
import quotesEs from './quotes_es'
import quotesPt from './quotes_pt'
import quotesFr_ca from './quotes_fr_ca'
import quotesDe_at from './quotes_de_at'
import quotesEn_ph from './quotes_en_ph'
import quotesEn_at from './quotes_en_at'
import quotesIt from './quotes_it'
import quotesEn_ae from './quotes_en_ae'
import { initQuotesDefault } from './quotes_default'

export const language = document.documentElement.lang
const ALL_QUOTES = {
  en: quotesEn,
  es: quotesEs,
  pt: quotesPt,
  it: quotesIt,
  'es-mx': quotesEs,
  'de-at': quotesDe_at,
  'en-in': quotesEn,
  'fr-ca': quotesFr_ca,
  'en-ph': quotesEn_ph,
  'en-at': quotesEn_at,
  'en-ae': quotesEn_ae
}

const initQuotesWidget = async () => {
  const widgetContainers = Array.from(document.querySelectorAll('.quotes_widget_block'))
  if (widgetContainers.length) {
    initQuotesDefault(ALL_QUOTES[language], widgetContainers)
  }
}

export default initQuotesWidget
